import en from 'translations/en/countries.json';
import pl from 'translations/pl/countries.json';
import sl from 'translations/sl/countries.json';
import { ITranslations } from 'types/common';
import { CountriesTransFields } from './types';

export const countriesTranslations: ITranslations<CountriesTransFields> = {
  name: 'countries',
  en,
  pl,
  sl,
};
